import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Root = styled.div((props) => {
  const { $center } = props;
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: $center?.vertical ? "center" : undefined,
    alignItems: $center?.horizontal ? "center" : undefined,
  };
});

function Container(props) {
  const { center, children, style } = props;
  return (
    <Root
      data-component-name="container"
      $center={center}
      style={{
        paddingTop: style?.padding?.top,
        paddingBottom: style?.padding?.bottom,
        paddingLeft: style?.padding?.left,
        paddingRight: style?.padding?.right,
        maxWidth: style?.maxWidth,
        textAlign: style?.textAlign,
        width: style?.width,
      }}
    >
      {children}
    </Root>
  );
}

Container.propTypes = {
  center: PropTypes.shape({
    horizontal: PropTypes.bool,
    vertical: PropTypes.bool,
  }),
  style: PropTypes.shape({
    padding: PropTypes.shape({
      top: PropTypes.number,
      bottom: PropTypes.number,
      left: PropTypes.number,
      right: PropTypes.number,
    }),
    maxWidth: PropTypes.number,
    textAlign: PropTypes.string,
    width: PropTypes.number,
  }),
  children: PropTypes.node,
};

export default Container;
